import { render, staticRenderFns } from "./OrderPartnerAttachments.vue?vue&type=template&id=3f69cac7&scoped=true&"
import script from "./OrderPartnerAttachments.vue?vue&type=script&lang=js&"
export * from "./OrderPartnerAttachments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f69cac7",
  null
  
)

export default component.exports